






















































































































































































import { ConfirmModal, DropdownMenu } from '@/app/components';
import { useFilters } from '@/app/composable';
import { AssetTypeIcon } from '@/modules/asset/components';
import { AssetType, AssetTypeId } from '@/modules/asset/constants';
import { CalendarIcon, ClockIcon, DotsVerticalIcon } from '@vue-hero-icons/solid';
import { PropType, Ref, computed, defineComponent, ref } from '@vue/composition-api';
import { RetrievalAccessibility, RetrievalStatus } from '../constants';
import { RetrievalQuery } from '../interfaces';

export default defineComponent({
    name: 'RetrievalQueryCard',
    props: {
        retrievalQuery: {
            type: Object as PropType<RetrievalQuery>,
            required: true,
        },
    },
    components: { CalendarIcon, ClockIcon, DotsVerticalIcon, DropdownMenu, ConfirmModal, AssetTypeIcon },
    setup(props, { root }) {
        const { formatDateAs } = useFilters();
        const showDeleteModal: Ref<boolean> = ref<boolean>(false);

        const assetType = (typeId: number) => {
            switch (typeId) {
                case AssetTypeId.Model:
                    return AssetType.Model;
                case AssetTypeId.Result:
                    return AssetType.Result;
                default:
                    return AssetType.Dataset;
            }
        };

        const assetClass = (type: string) => {
            switch (type) {
                case AssetType.Result:
                    return 'text-blue-800';
                case AssetType.Model:
                    return 'text-cherry-700';
                default:
                    return 'text-orange-800';
            }
        };

        // Only the first few assets are rendered as chips; the rest are summarised by a "+N more" chip.
        const MAX_VISIBLE_ASSETS = 6;
        const visibleAssets = computed(() => (props.retrievalQuery.assets || []).slice(0, MAX_VISIBLE_ASSETS));
        const hiddenAssets = computed(() => (props.retrievalQuery.assets || []).slice(MAX_VISIBLE_ASSETS));
        const hiddenAssetsTooltip = computed(() =>
            hiddenAssets.value.map((asset) => `${asset.name}${asset.available ? '' : ' (not available)'}`).join(', '),
        );

        const actionOptions = computed(() => [
            {
                name: 'Edit',
                action: () =>
                    root.$router.push({ name: 'retrieval:edit', params: { id: `${props.retrievalQuery.id}` } }),
            },
            { name: 'Delete', action: () => (showDeleteModal.value = true) },
        ]);

        return {
            RetrievalStatus,
            RetrievalAccessibility,
            showDeleteModal,
            formatDateAs,
            assetType,
            assetClass,
            visibleAssets,
            hiddenAssets,
            hiddenAssetsTooltip,
            actionOptions,
        };
    },
});
